import filter from 'lodash/fp/filter'

export default {

    all: state => Object.values(state.entities),

    allByVariantId: (state, getters) => variantId => {
        return filter(['variant', variantId])(getters['all'])
    }

}


